/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import CompanyDetailsCommonHeader from "../../CompanyDetailsCommonHeader/CompanyDetailsCommonHeader";
import PeopleHeader from "../Header/PeopleHeader";

const PeopleBody = () => {
  const { t, i18n } = useTranslation(); //for translation

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const moduleAccess = localStorage.getItem("moduleaccess");

  const [isLoading, setIsLoading] = useState(false);
  const [peopleList, setPeopleList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [selectedUserEmails, setSelectedUserEmails] = useState("");

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for company details
  const getCompanyDetails = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_COMPANY_DETAILS +
        `/${params.id}?token=${token}&modulefrom=backend`;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        const companyName = response.data.name;

        let appUserRequestUrl =
          url.API_BASE_URL +
          url.API_GET_APP_USERS +
          `?token=${token}&modulefrom=backend&&filtercompany=${companyName}`;

        const appUserResponse = await getData(appUserRequestUrl);

        setIsLoading(false);

        console.log("response of app user list------>", appUserResponse);

        if (appUserResponse.status && appUserResponse.data) {
          setPeopleList(appUserResponse.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    params.id && getCompanyDetails();
  }, [params.id]);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: t("Name"),
        Cell: ({ renderedCellValue, row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              width: "150px",
            }}
          >
            <img
              height={30}
              width={30}
              src={
                row.original.userimage
                  ? url.SERVER_URL + row.original.userimage
                  : assetImages.defaultUser
              }
              loading="lazy"
              style={{ borderRadius: "50%" }}
            />
            <span>{renderedCellValue}</span>
          </Box>
        ),
      },
      {
        accessorKey: "surname",
        header: t("Surname"),
      },
      {
        accessorKey: "email",
        header: t("Email"),
      },
      {
        accessorKey: "position",
        header: t("Position"),
      },

      {
        accessorKey: "phone",
        header: t("Phone"),
      },
      {
        accessorKey: "city",
        header: t("Location"),
      },
      {
        accessorKey: "country",
        header: t("Country"),
      },
    ],
    [i18n.language]
  );

  useEffect(() => {
    //do something when the row selection changes...
    // console.info("rowSelection", rowSelection);
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      const selectUserIds = selectedIdsArray.map((id) => {
        const [userId] = id.split("-");
        return userId;
      });
      const selectUserEmails = selectedIdsArray.map((id) => {
        const [, userEmail] = id.split("-");
        return userEmail;
      });
      setSelectedUserIds(selectUserIds);
      const selectUserEmailString = selectUserEmails.join(",");
      setSelectedUserEmails(selectUserEmailString);
    } else {
      setSelectedUserIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_USER")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- companies common header ---- */}
          {params.id && <CompanyDetailsCommonHeader moduleName="peoples" />}

          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            <PeopleHeader reloadCompanyMemberList={getCompanyDetails} />
            {/* ---- table with pagination section start ---- */}
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={peopleList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  // enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}-${row.email}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  // enableRowActions // show the action column
                  //localization={MRT_Localization_ES} // localization
                  renderRowActionMenuItems={({ row }) => {
                    const [appUserId] = row.id.split("-");

                    return [
                      <MenuItem key="Profile">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/profile/${appUserId}`}
                        >
                          {t("Manage Profile")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="CV">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/cv/${appUserId}`}
                        >
                          {t("Manage CV")}
                        </Link>
                      </MenuItem>,
                      // <MenuItem
                      //   key="Surveys"
                      //   //onClick={() => console.info(expertId)}
                      // >
                      //   <Link
                      //     className="dropdown-item"
                      //     to={`/admin/appuser/surveys/${expertId}`}
                      //   >
                      //     Manage Surveys
                      //   </Link>
                      // </MenuItem>,
                      <MenuItem
                        key="Privacy"
                        //onClick={() => console.info(expertId)}
                      >
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/privacy/${appUserId}`}
                        >
                          {t("Manage Privacy")}
                        </Link>
                      </MenuItem>,

                      <MenuItem key="Password">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/password/${appUserId}`}
                        >
                          {t("Manage Password")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="avalibility">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/availability/${appUserId}`}
                        >
                          {t("Manage Availability")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="settings">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/settings/${appUserId}`}
                        >
                          {t("Manage Settings")}
                        </Link>
                      </MenuItem>,
                      <MenuItem key="survey">
                        <Link
                          className="dropdown-item"
                          to={`/admin/appuser/surveyinvites/${appUserId}`}
                        >
                          {t("View Survey Invites")}
                        </Link>
                      </MenuItem>,
                    ];
                  }} // action columns menu items
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
            {/* ---- table with pagination section end ---- */}
          </div>
        </section>
        {/* ======== popups and modals area ======== */}

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default PeopleBody;
